<template>
  <div class="table-container">

  
  <!-- <q-input v-model="tableFilter" v-if="includeFilter" outlined dense placeholder="Search for a row..." class="q-mt-sm q-mb-sm"/> -->
  <q-table
    bordered
    :title=title
    :rows="rows"
    :columns="columns"
    row-key="name"
    dense
    class="fixed-table"
    :filter="tableFilter"
    :flat="flat"
    :table-colspan="columns.length"
    :virtual-scroll="false"
    :hide-header="hideHeader"
    :hide-bottom="hideBottom"
  >

    <template v-slot:header="props">
      <q-tr :props="props" class="bg-black text-white">
        <q-th
          v-for="col in props.cols"
          :key="col.name"
          :props="props" 
          :style="col.style" 
          :class="getBirdSeasons(col)"
  
        >
          <span class="text-bold text-center ">{{ col.label }}</span>
        </q-th>
      </q-tr>
    </template>

    <template v-slot:body="props">
      <!-- hide the breeding schedule row -->
      <q-tr :props="props" v-if="props.row.name != 'Breeding' || (props.row.name == 'Breeding' && !hideBreeding)">
        <q-td
          v-for="(col, i) in props.cols"
          :key="col.name"
          :props="props"
          :style="col.style"

        >
          <div class="row">
            <div class="col q-pa-none" @click="cellClick(col, props.row)" >
              <div v-if="labelCells || col.name === 'name'"> 
                <!-- column labels -->
                <span v-if="props.row.name != 'Breeding'" 
                  class="cell-label" 
                  :class="col.name != 'name' ? 'absolute-center' : ''"
                  :style="getLabelColors(col.value)"
                  >
                  {{ col.value }}
                </span>

                <div v-else >
                  <div v-if="!hideBreeding" :style="{ 'padding-bottom' :'6px', 'min-width':'113%'}" :class="getBirdSeasons(col)" class="text-white">
                    Breeding
                  </div>
                </div>
              </div>
              <div id="breedSched" :style="{'min-height' : '100%', 'margin-bottom' :'6px'}" v-if="props.row.name == 'Breeding' && col.name != 'name' && !hideBreeding" :class="getBirdSeasons(col)"  >&nbsp</div>
                          
                <!-- to highlight cells, the clickedCell is a bit diffrent for  -->
               
                <Donut 
                  v-if="isObject(props.row[col.name]) && donuts && !dependence"
                  name=""
                  :divName="birdDonutDivName(props.row.ecoCode, i)"
                  :colors="cellColors"
                  :data="props.row[col.name]"
                  :class="highlightClickedCell(props.row, col)"
                  class="pointer"
                />
                <div v-else>
                  <div v-if="!dependence" :class="highlightClickedCell(props.row, col)" class="pointer">     
                    <span v-if="getPercOfMaxVal(props.row[col.name]) >=50"  ><q-icon name="circle" color="purple-10" size="lg"/></span>
                    <span v-else-if="getPercOfMaxVal(props.row[col.name]) >=40" ><q-icon name="circle" color="purple-8" size="lg"/></span>
                    <span v-else-if="getPercOfMaxVal(props.row[col.name]) >=30"  ><q-icon name="circle" color="purple-6" size="lg"/></span>
                    <span v-else-if="getPercOfMaxVal(props.row[col.name]) >=20" ><q-icon name="circle" color="purple-4" size="lg"/></span>
                    <span v-else-if="getPercOfMaxVal(props.row[col.name]) >=1" ><q-icon name="circle" color="purple-2" size="lg"/></span>
                    <span v-else-if="!['', 'pre', 'post', 'breed'].includes(props.row[col.name]) && col.name != 'name'"><q-icon name="circle" color="grey-2" size="lg"/></span>
                    <q-tooltip v-if="getPercOfMaxVal(props.row[col.name]) >0">{{ getPercOfMaxVal(props.row[col.name]) }}% of the  {{ ecos[props.row.ecoCode]}} ecoregion portion of the study area is a core area for {{ AllCodes[props.row.spID] }}</q-tooltip>
                  </div>
                </div>
                <div v-if="dependence" :class="highlightClickedCell(props.row, col)" class="pointer">
                  <span v-if="getDependVal(props.row[col.name], props.row.max) >=50"  ><q-icon name="circle" color="green-10" size="lg" /></span>
                  <span v-else-if="getDependVal(props.row[col.name], props.row.max) >=40" ><q-icon name="circle" color="green-8" size="lg" /></span>
                  <span v-else-if="getDependVal(props.row[col.name], props.row.max) >=30"  ><q-icon name="circle" color="green-6" size="lg" /></span>
                  <span v-else-if="getDependVal(props.row[col.name], props.row.max) >=20" ><q-icon name="circle" color="green-4" size="lg"/></span>
                  <span v-else-if="getDependVal(props.row[col.name], props.row.max) >=1" ><q-icon name="circle" color="green-2" size="lg"/></span>
                  <span v-else-if="!['', 'pre', 'post', 'breed'].includes(props.row[col.name]) && col.name != 'name'"><q-icon name="circle" color="grey-2" size="lg" :label="props.row[col.name]"/></span>
                  <q-tooltip v-if="getDependVal(props.row[col.name], props.row.max) >0">{{ getDependVal(props.row[col.name], props.row.max) }}% of all {{ AllCodes[props.row.spID] }} core habitat in the Atlantic region is in the {{ ecos[props.row.ecoCode]}} ecoregion in {{ col.name }}</q-tooltip>
                </div>        
            </div>

          </div>

        </q-td>
        
      </q-tr>
      <q-tr v-show="props.expand" :props="props">
        <q-td colspan="100%">
          <div class="text-left">This is expand slot for row above: {{ props.row.name }}.</div>
        </q-td>
      </q-tr>
    </template>

  </q-table>
</div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, toRefs, computed, PropType } from "vue";
import { QTableColumn } from 'quasar'
import { useMapItems } from "../composables/useMapItems";
import { useHelpers } from "../composables/useHelpers";

import { useRouter } from 'vue-router';
import Donut from "./Donut.vue";
import { AllCodes } from '../assets/SppCodesToNames.json'
const router = useRouter();


const {  styleMap, setLegend, toggleLayer, map, tileLayers, activeLayerID, ecos} = useMapItems()
const { arrayFindObjectByProp, getKeyByValue, months, sumArray } = useHelpers();

const passedProps = defineProps({
  version: {type: Number, default: null},
  rows:{type: Array, default: null},
  columns:{type: Array as PropType<QTableColumn[]>, default: null},
  title: {type: String, default: null},
  expandRows: {type:Boolean, default: false},
  includeFilter:{type:Boolean, default: true},
  mapStyle: {type: Boolean, default: false},
  mapStops: {type: Array, default: null}, // array of map stops used if styling the map
  mapStopFunc: {type: Function, default: null}, //CAS thresholds are difference for each commnity, so need function to generate
  mapClassNames: {type: Object, default: null}, // object of names for map values used in legend.  e.g. { 90 : "Very High"}
  cellColors: {type:Object, default: null}, // an object version of the array passed in as mapStops
  colorFunc: {type: Function, default: null}, // a function used to define color ranges.  As in:    getColor(v) { if (v >= 75) return '#006d2c' 
                                                                                                      // else if (v >= 50 && v < 75) return '#31a354'
                                                                                                      // else if (v >= 25 && v < 50) return '#74c476'
                                                                                                      // else if (v >= 10 && v < 25) return '#bae4b3'
                                                                                                      // else if (v > 0 && v < 10) return '#edf8e9'
                                                                                                      // else return '#d1d1d1'
  labelColorFunc: {type: Function, default: null}, // same as above, but used for white labels if color is dark
  labelCells: {type:Boolean, default: true},
  mapStyleType: {type: String, default: 'categorical'}, // can also pass in 'interpolate' for continuous data
  mapLayer: {type: String, default: null}, // if a single layer is used, pass that in.  If this then should not be colTolayerObj
  mapLegendTitles : {type: Object, default: null}, // layer title for the legend.  e.g. Fish High Biomass (1990s)
  manualMapLegend: {type: Object, default: null}, // for CAS, easier to just pass in a plain object
  additionalClickFunc: {type: Function, default: null}, // osomething to happen on cell click.  For CAS, highlight the selected port point on map
  season: {type: String, default: null}, // fish by decade need the season so can get that layer on map click
  breedingSeasons:{type: Object, default: null }, // the breeding seasons for the active species.  used for teal bars
  coastal: {type: Boolean, default: false},
  donuts: {type: Boolean, default: false}, // whether to show donuts or the % of the "Very High" class
  flat:{type: Boolean, default: false}, // whether the card is flat
  showLegend:{type: Boolean, default: true}, // whether to show the breeding season legend
  hideHeader:{type: Boolean, default: false}, // whether to show the header... can leave out for coastal so not repeated
  hideBottom:{type: Boolean, default: false}, // whether to show the footer... can leave out for coastal so not repeated
  hideBreeding:{type: Boolean, default: false}, // whether to show the breeding schedule row... can leave out for coastal so not repeated
  dependence:{type: Boolean, default: false}, // if true, values are % based and dived by max getDependVal
})


const { dependence, hideBreeding, hideBottom, hideHeader, showLegend, flat, donuts, coastal, rows, columns, title, expandRows, includeFilter, mapStyle, mapStops, mapStopFunc, mapClassNames, cellColors, colorFunc, labelColorFunc, mapLayer, mapLegendTitles, manualMapLegend, season, additionalClickFunc, mapStyleType, breedingSeasons } = toRefs(passedProps)




  

  const colorOnGradient =(hex1, hex2, minVal, maxVal, value) => {
    // Convert hex to RGB
    function hexToRgb(hex) {
        let bigint = parseInt(hex.slice(1), 16);
        return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
    }

    // Convert RGB to hex
    function rgbToHex(r, g, b) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
    }

    // Normalize the value to a range between 0 and 1
    let t = (value - minVal) / (maxVal - minVal);
    t = Math.max(0, Math.min(1, t)); // Ensure t is within [0, 1]

    // Interpolate between the two colors
    let rgb1 = hexToRgb(hex1);
    let rgb2 = hexToRgb(hex2);
    let r = Math.round(rgb1[0] + t * (rgb2[0] - rgb1[0]));
    let g = Math.round(rgb1[1] + t * (rgb2[1] - rgb1[1]));
    let b = Math.round(rgb1[2] + t * (rgb2[2] - rgb1[2]));

    return rgbToHex(r, g, b);
  }

  const getColors = (v, row, colObj) =>{

    //this is for categorical attribtues where the colors are mapped to categorical values
    if (cellColors.value){
      const style = {'color' :  cellColors.value[v] }
      return style
    }
    
    // this is a function that is passed from the component
    // needed to apply more dynamic styles.. like for the CAS data
    // which uses different thresholds to define "High Intensity" for 
    // each community
    else if (colorFunc.value){
      let style

      return style
    }

    // if neither of above, use a gradient
    else{
      const style = {'color' : colorOnGradient('#d0daf5', '#012175', 0, 300, v)}
      return style
    }
  }



  const getLabelColors = (v) =>{
    // used so that dark icons can have a white label.  
    // Passed as a fcuntion from component.  See People component
    if (labelColorFunc.value){
      const style = {'color' : labelColorFunc.value(v)}
      return style
    }
    const style = {'color' :'black'}
    return style
  }


  const clickedCell = ref(null)
  const cellClick = (colObj, row) =>{
    // console.log(colObj)
    // console.log(row)
    // if there's a function to run on cell click, pass that in
    if (additionalClickFunc.value){
      additionalClickFunc.value(colObj, row)
    }
    

    // if the cells can be clicked to style the map, this function
    // highlights the cell that was clicked
    if (mapStyle.value === true){
      // console.log(colObj);
      // console.log(row);
      let layerID;
      let sp

      // if the map layer is passed in, then that's what it is
      if(mapLayer.value){
        layerID = mapLayer.value;
      }

      // for fish the season is in the tile layer name
      else if(season.value){
        sp = row.spID;
        layerID = `FISH_TIME_${season.value}_${sp}` //colObj.name;
        // console.log(layerID)
      }


      let styleAttr
      // getting attribute used to style the map is a bit different for each component

      if (layerID.includes("FISH")){  
        styleAttr = colObj.name;
        sp = row.spID;
        // this is used to apply a highlight to the clicked cell in the table
        clickedCell.value = sp + colObj.name;
      }
      else if (layerID.includes("MAMMAL") || layerID.includes("BIRD") || layerID.includes("TURTLE") ){
        const monthCode = getKeyByValue(months, colObj.name)
        styleAttr = row.spID + "_" + monthCode
        // console.log(sp)
        // console.log(row.spID)
        clickedCell.value = styleAttr;
      }


      // console.log(clickedCell.value)
      // console.log(`style ${layerID} by ${sp}`)
      const layer = arrayFindObjectByProp(tileLayers.value, 'id', layerID)
     

  
      // if the layer isn't in the map, toggle it on
      // this happens when moving between decades
      let theseMapStops
      if (mapStops.value){theseMapStops = mapStops.value}
      else if (mapStopFunc){ // CAS data
        theseMapStops = mapStopFunc.value(clickedCell.value)
      }

      
      if (map.value.getLayer(layerID) === undefined) {
        toggleLayer(true, layer, null) // null value -- no need to zoom to the polygon, since only styling, not querying
        map.value.once('idle', function(){
          styleMap(layerID, styleAttr, mapStyleType.value,  theseMapStops, mapClassNames.value)
        })
      }
      // changing attr within a layer already in the map
      else{
        styleMap(layerID, styleAttr, mapStyleType.value,  theseMapStops, mapClassNames.value)
      }

      // console.log(theseMapStops)
      if (manualMapLegend.value){
        const name = colObj.label + ": " + row.name 
        setLegend(name, manualMapLegend.value )
      }
      else if (mapLegendTitles.value){
        let attrName = row.name
        if (!sp){
          attrName = AllCodes[row.spID];
        }
        setLegend(attrName + " " + mapLegendTitles.value[colObj.name],  theseMapStops, mapClassNames.value)
      }
      else{
        setLegend(colObj.name,  theseMapStops, mapClassNames.value)
      }
      
    }
    
  }

const highlightClickedCell = (row=null, col=null)=>{
  // console.log(row)


  //mammals & birds
  if (row && row.spID && (row.spID + "_" + getKeyByValue(months, col.name) == clickedCell.value)){
    // only highlight the active col in the coastal or offshore, depending on which was clicked-- match to activeLayerID
    if (coastal.value && activeLayerID.value.includes('COASTAL') || !coastal.value && !activeLayerID.value.includes('COASTAL') ){
      if (donuts.value){
        return 'highlight-donut-cell'
      }
      else{
        return 'highlight-text-cell'
      }
      
    }
  }

  // not highlighted
  else{
    return ''
  }
}

const tableFilter = ref('')
const getLabelVal = (v, colObj, row) =>{
  if(mapLayer.value && mapLayer.value.includes("CAS")){ 

  }
  else{
    // otherwise show <1 for values <1 else the value
    if (v>0 && v < 1){return '<1'}
    else{return v}
  }

}



const birdDonutDivName = (eco, i) =>{
  return "donut" + "_" + mapLayer.value + "_" + eco + "_" +i
}
const birdTableCellColors ={
  "95" : "#830C5D",
  "90" : "#F16DC6",
  "75" : "#EEB3DA",
  // "1" : "#ffffb2",
  "0"  : "#F7E8F2",
  "-9" : "#a1a1a1"
}

const getPercOfMaxVal = (data) =>{
  // console.log(data)
  // console.log(mapLayer.value)
  // console.log(rows.value)
  if (data != undefined){
    const total = []
    for (const [key, value] of Object.entries(data)) {
      total.push(value)
    }

    // offshore data abundance based on VERY HIGH class only
    if (!mapLayer.value.includes('COASTAL')){
      if (data['Very High']){
        return (Math.round(data['Very High'] / sumArray(total) * 100 *10)/10)
      }
      else{
        return null
      }
    }

    // coastal data is based on HIGH or VERY HIGH classes (75 + 90)
    else if (mapLayer.value.includes('COASTAL')){
      if (data['Very High'] || data['High']) {
        const value = (data['Very High'] || 0) + (data['High'] || 0);
        return Math.round((value / sumArray(total) * 100 * 10) / 10);
      }
      return null;
    }

  }
  else{
    return null
  }
}

const getDependVal = (data, max) =>{
  // console.log(data)
  // console.log(max)
  // console.log(mapLayer.value)
  if (data != undefined){
    const total = []
    for (const [key, value] of Object.entries(data)) {
      total.push(value)
    }

    // offshore data abundance based on VERY HIGH class only
    if (!mapLayer.value.includes('COASTAL')){
      if (data['Very High']){
        return (Math.round(data['Very High'] / max * 100 *10)/10)
      }
      else{
        return null
      }
    }

    // coastal data is based on HIGH or VERY HIGH classes (75 + 90)
    else if (mapLayer.value.includes('COASTAL')){
      if (data['Very High'] || data['High']) {
        const value = (data['Very High'] || 0) + (data['High'] || 0);
        return Math.round((value / max * 100 * 10) / 10);
      }
      return null;
    }

  }
  else{
    return null
  }
}

const getBirdSeasons = (month) =>{
  // console.log(month)
  // console.log(breedingSeasons.value)
 
  if (breedingSeasons.value && breedingSeasons.value[month.name] == 'breed'){
    return 'bg-teal-6'
  }
  else if (breedingSeasons.value && breedingSeasons.value[month.name] == 'pre'){
    return 'bg-teal-2 text-black'
  }
    else if (breedingSeasons.value && breedingSeasons.value[month.name] == 'post'){
    return 'bg-teal-2 text-black'
  }
  else{
    return 'bg-grey-9'
  }
}

const isObject = (variable) =>{
    return typeof variable === 'object' || variable instanceof Object;
}


const  initialPagination ={
  sortBy: 'desc',
  descending: false,
  page: 2,
  rowsPerPage: 5
  // rowsNumber: xx if getting data from a server
}
  // DATA FORMAT
  // TS error on coluns: See https://github.com/quasarframework/quasar/issues/13036#issuecomment-1086695817
  // const columns: QTableColumn[] = [
  //   {
  //     name: 'name',
  //     required: true,
  //     label: 'Demersal Fish',
  //     align: 'left',
  //     field: row => row.name,
  //     format: val => `${val}`,
  //     sortable: true
  //   },
  //   { name: 'calories', align: 'center', label: 'Jan', field: 'calories', sortable: true },
  //   { name: 'fat', align: 'center', label: 'Feb', field: 'fat', sortable: true },
  //   { name: 'carbs', align: 'center', label: 'Mar', field: 'carbs' },
  //   { name: 'protein', align: 'center', label: 'Apr', field: 'protein' },
  //   { name: 'sodium',align: 'center', label: 'May', field: 'sodium' },
  //   { name: 'calcium', align: 'center', label: 'Jun', field: 'calcium', sortable: true, sort: (a, b) => parseInt(a, 10) - parseInt(b, 10) },
  //   { name: 'iron', align: 'center', label: 'Jul', field: 'iron', sortable: true, sort: (a, b) => parseInt(a, 10) - parseInt(b, 10) }
  // ]

  // const rows = [
  //   {
  //     name: 'American Plaice',
  //     calories: 159,
  //     fat: 6.0,
  //     carbs: 24,
  //     protein: 4.0,
  //     sodium: 87,
  //     calcium: '14%',
  //     iron: '1%'
  //   },
  //   {
  //     name: 'Goosefish',
  //     calories: 237,
  //     fat: 9.0,
  //     carbs: 37,
  //     protein: 4.3,
  //     sodium: 129,
  //     calcium: '8%',
  //     iron: '1%'
  //   },
  // ]
</script>
<style scoped>
.med-text{
  font-size: 14px;
}

.q-dark .text .d3-text{
  fill: white !important;
}
/* .my-table{
  overflow-x: scroll;
} */
.cell-label{
   z-index: 10;
   text-wrap: wrap;
}

.pointer{
  cursor: pointer;
}
.disable-click{
  pointer-events: none;
}
.highlight-donut-cell{
  box-shadow: 5px 5px 5px #252525;
  border-radius: 50%;
}
.highlight-text-cell{
  box-shadow: 5px 5px 5px #252525;
  border-radius:100%;

}

.fixed-table{
  table-layout: fixed;
  width: 100% !important;
  overflow-x: hidden;
}
.custom-footer{
  min-width:100%;
}
.custom-div-left{
  min-width:100%;
}

.circle{
  border-radius: 50%;
  border: 2px solid;
  padding: 2px;
}

.table-container{
  width: 109% !important;
  overflow: hidden !important;
}
</style>
